import { render, staticRenderFns } from "./buyairtime.vue?vue&type=template&id=72176cd0"
import script from "./buyairtime.vue?vue&type=script&lang=js"
export * from "./buyairtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports